import React from "react";
import PropTypes from "prop-types";
import Card from "components/Card";
import { Col } from "components/Containers";
import { Spinner } from "components/Loader";
import { RoleDescription, RoleDetails } from "components/Missions/Roles";
import BlueprintVetting from "./BlueprintVetting";

/**
 * RoleReview
 *
 * Everything the customer has entered, read only, before the draft is submitted.
 *
 * @param {Object}   role     The draft being built
 * @param {Boolean}  loading  The draft is still being read back
 */
const RoleReview = ({ role, loading }) => {
  if (loading || !role?.id) return <Spinner />;

  return (
    <Col gap="2rem">
      <Card>
        <RoleDescription role={role} />
      </Card>
      <Card>
        <RoleDetails role={role} mission={role.mission} />
      </Card>
      <BlueprintVetting role={role} canEdit={false} />
    </Col>
  );
};

RoleReview.propTypes = {
  role: PropTypes.object,
  loading: PropTypes.bool,
};

export default RoleReview;
